import { useApi } from '@/api'

export const useVerificationResource = () => {
  const api = useApi()
  const verificationOf = (organizationId: string) => api.api.v1.organizations({ organizationId }).verification
  const requests = api.api.v1.admin['verification-requests']

  type SubmissionBody = Parameters<ReturnType<typeof verificationOf>['post']>[0]
  type ReviewBody = Parameters<ReturnType<typeof requests>['review']['post']>[0]

  return {
    getVerification: (organizationId: string) => verificationOf(organizationId).get(),
    setVerification: (organizationId: string, body: SubmissionBody) => verificationOf(organizationId).post(body),
    getVerificationRequests: () => requests.get(),
    setVerificationRequestReview: (requestId: string, body: ReviewBody) => requests({ requestId }).review.post(body)
  }
}
